import unreleaseTripMessagesModule from "./unreleaseTripMessagesModule"
import server from "../server"

unreleaseTripMessagesModule.service("unreleaseTripMessagesService", ["$http", function searchService($http) {

    this.filter = (template, firstResult, maxResults) => {
        return $http.post(server.getServiceUrl("search.unreleaseTripMessages") + "presentation-tree", template, {
            params: {
                firstResult,
                maxResults
            }
        }).then((response) => response.data)
    }

    this.find = (recordId) => {
        return $http.get(server.getServiceUrl("unreleaseTripMessages") + recordId)
            .then((response) => response.data)
    }

    this.forceProcessMessage = (recordId) => {
        return $http.get(server.getServiceUrl("unreleaseTripMessages-forceProcess") + recordId)
            .then((response) => response.data)
    }
}])